// client/src/components/AboutSnippet.js
import React from 'react';
import { Link } from 'react-router-dom';
import './AboutSnippet.css';

const AboutSnippet = () => {
  return (
    <section className="about-snippet-section">
      <div className="container">
        <h2>Pioneering Medical Solutions in Tanzania</h2>
        <p>
          Established two years ago, Makah Medics has rapidly emerged as a
          trusted leader in the supply and maintenance of high-quality medical
          equipment and supplies across Tanzania. Strategically located in Dar
          es Salaam, Tegeta, we are dedicated to advancing healthcare standards...
        </p>
        <Link to="/about" className="btn btn-primary">
          Read More About Us
        </Link>
      </div>
    </section>
  );
};

export default AboutSnippet;